import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { CellClassRules, ColDef, ColumnApi, GridApi, GridOptions } from 'ag-grid-enterprise';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { ReportService } from '../..';
import 'ag-grid-enterprise';

@Component({
    selector: 'app-biz-dev-dashboard',
    templateUrl: './biz-dev-dashboard.component.html',
    styleUrls: ['./biz-dev-dashboard.component.css'],
    standalone: false
})
export class BizDevDashboardComponent implements OnInit {

 @Input() showSearchUI = true;
 	bizDevAPI: any = [];
	propertyDevelopments: any = [];

	constructor(
		public messageService: MessageService,
		public reportService: ReportService) { }


	// forms
	formLoading = false;
	columnApi: ColumnApi;

	// to hold the current search
	currentSearchForm: any;

	ngOnInit(): void {

	}

	onSearchSubmit(searchForm: any) {
		this.currentSearchForm = searchForm;
		this.runBizDevReport(searchForm);
	}

	runBizDevReport(searchForm) {
		try {
			this.formLoading = true;
			console.log('Request data', searchForm);
			this.reportService.bizDevReport(searchForm)
				.subscribe(
					res => {
						console.log('bizDevReport SUCCESS: ' + JSON.stringify(res));
						this.bizDevAPI = res.data.bizDevProperty.bizDevAPIS[0];
						this.propertyDevelopments = this.bizDevAPI.propertyDevelopments;
						this.columnApi.autoSizeAllColumns();
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 3000 });
					},
					err => {
						console.log('runReservationRevenueReport FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Error', detail: err.message });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error: runReservationRevenueReport' });
		}
	}

	ngAfterViewInit(): void {
	}

}
